exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .theme--light.v-messages{color:rgba(0,0,0,.54)}.qmodii .theme--dark.v-messages{color:hsla(0,0%,100%,.7)}.qmodii .application--is-rtl .v-messages{text-align:right}.qmodii .v-messages{flex:1 1 auto;font-size:12px;min-height:12px;min-width:1px;position:relative}.qmodii .v-messages__message{line-height:normal;word-break:break-word;overflow-wrap:break-word;word-wrap:break-word;hyphens:auto}", ""]);

// exports
